export function PullRequestsCommits() {
  return (
    <>
      <h2 data-hpc>PullRequestsCommits</h2>
    </>
  )
}

try{ PullRequestsCommits.displayName ||= 'PullRequestsCommits' } catch {}